import React from "react";
import { Link } from "react-router-dom";
import { inr } from "../../lib/api";
import { ArrowRight, FileText, Languages, Clock, Check } from "lucide-react";
import { Button } from "../ui/button";

export function ProductCard({ p, testid }) {
  const isFree = p.price === 0 || p.type === "Free Test";
  const save = p.mrp > p.price ? p.mrp - p.price : 0;
  return (
    <div data-testid={testid || `test-product-card-${p.id}`}
      className="group relative panel p-5 sm:p-6 flex flex-col hover:border-white/20 transition-all duration-300">
      <div className="flex items-center justify-between mb-4">
        <span className="text-[11px] font-medium text-content-secondary uppercase tracking-wider">{p.exam_slug?.toUpperCase()}</span>
        {isFree
          ? <span className="chip !py-1 !text-[10px] !text-status-answered">Free</span>
          : <span className="chip !py-1 !text-[10px]">{p.type}</span>}
      </div>
      <h3 className="font-heading font-semibold text-[15px] leading-snug mb-4 group-hover:text-ember transition-colors">{p.name}</h3>

      <div className="grid grid-cols-2 gap-2.5 mb-6 text-[12px]">
        {p.num_tests ? <Meta icon={FileText} v={`${p.num_tests} tests`} /> : null}
        {p.num_questions ? <Meta icon={Check} v={`${p.num_questions.toLocaleString("en-IN")} MCQs`} /> : null}
        {p.language ? <Meta icon={Languages} v={p.language} /> : null}
        {p.validity_days ? <Meta icon={Clock} v={`${Math.round(p.validity_days / 30)} mo`} /> : null}
      </div>

      <div className="mt-auto flex items-end justify-between pt-4 border-t border-line">
        <div>
          {isFree ? (
            <span className="font-heading font-bold text-lg text-status-answered">Free</span>
          ) : (
            <div className="flex items-baseline gap-2">
              <span className="font-heading font-bold text-xl">{inr(p.price)}</span>
              {save > 0 && <span className="text-[13px] text-content-muted line-through">{inr(p.mrp)}</span>}
            </div>
          )}
          {save > 0 && !isFree && <div className="text-[11px] text-status-answered mt-0.5">You save {inr(save)}</div>}
        </div>
        <Button asChild size="sm" className="btn-ember rounded-full h-9 px-4 text-[13px]" data-testid={`test-buy-button-${p.id}`}>
          <Link to={`/product/${p.slug}`}>{isFree ? "Try Free" : "View"} <ArrowRight className="w-3.5 h-3.5 ml-1" /></Link>
        </Button>
      </div>
    </div>
  );
}
const Meta = ({ icon: Icon, v }) => (
  <span className="flex items-center gap-1.5 text-content-secondary"><Icon className="w-3.5 h-3.5 text-content-muted" /> {v}</span>
);

export function SectionHeader({ eyebrow, title, subtitle, center, className = "" }) {
  return (
    <div className={`${center ? "mx-auto text-center max-w-2xl" : "max-w-2xl"} ${className}`}>
      {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
      <h2 className="font-heading text-[26px] sm:text-3xl lg:text-[40px] font-bold leading-[1.1]">{title}</h2>
      {subtitle && <p className="text-dim mt-4 text-[15px] sm:text-base leading-relaxed">{subtitle}</p>}
    </div>
  );
}
